import { render, staticRenderFns } from "./ExpensesPieChart.vue?vue&type=template&id=5912c2d0&scoped=true&lang=pug&"
import script from "./ExpensesPieChart.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExpensesPieChart.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExpensesPieChart.vue?vue&type=style&index=0&id=5912c2d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5912c2d0",
  null
  
)

export default component.exports